export const environment = {
  production: false,
  envType: 'DEVELOPMENT',
  isFullOnline: true,
  caisseApiUrl: 'https://devgestion.quiditmiam.fr/api',
  title: 'Caisse Collective - Développement',
  buildDate: "2026-09-18T14:38:30",
  lastPipeline: "6577",
  version: "0.0.0",
  sentryDsn: '',
};
